import { NavLink } from "react-router-dom";

import getImgUrl from "../helper/getImgUrl";
import styles from "../styles/productcard.module.css";
import CurrencyDisplay from "./CurrencyDisplay";

const ProductCard = ({ product }) => {


    return (
        <div className={styles.product_card}>
            <div className={styles.product_image}>
                <img src={getImgUrl(product.images[0], 'product')} alt={product.alt} />
            </div>
            <div className={styles.product_info}>
                <div className={styles.product_title}>
                    <h2>{product.title}</h2>
                </div>
                <div className={styles.product_price}>
                    <div className={styles.material}>{product.materials.map((material, idx) => <p key={idx}>{material}</p>)}</div>
                    <h3>{<CurrencyDisplay amount={product.price} currency="CAD"/>}</h3>
                </div>
                <NavLink to={`/productpage/${product.id}`} className={styles.productbtn}><button>{
                    product.quantity > 0 ? 'View' :'Out of Stock'
                }</button></NavLink>
            </div>
        </div>
    )
}

export default ProductCard